<div *ngIf="isLoading"
    style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>

<div class="modal-header bg-soft-info p-3">
    <h5 class="modal-title" id="exampleModalLabel" i18n="@@">Checkout</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>




<div class="card-body checkout-tab">

    <div class="step-arrow-nav">
        <ul ngbNav #customNav="ngbNav" [(activeId)]="tabId" (navChange)="onNavChange($event)"
            class="nav nav-pills custom-nav nav-justified" role="tablist">
            <li [ngbNavItem]="1" class="nav-item">
                <a ngbNavLink class="nav-link fs-15 p-3" data-bs-toggle="tab" role="tab">
                    <i
                        class="ri-user-2-line fs-16 p-2 bg-soft-primary text-primary rounded-circle align-middle me-2"></i>
                    Personal Info
                </a>
                <ng-template ngbNavContent>
                    <div style="margin:  1.25rem;">
                        <div>
                            <h5 class="mb-1">Billing Information</h5>
                            <p class="text-muted mb-3">Please fill all information below</p>
                        </div>

                        <div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="mb-3">
                                        <label for="billinginfo-firstName" class="form-label">First Name</label>
                                        <input required #name="ngModel"
                                            [ngClass]="{ 'is-invalid': (name.invalid && ((name.dirty || name.touched) || submitted == true))}"
                                            class="form-control" type="text" [(ngModel)]="userModel.name"
                                            placeholder="Enter First Name" i18n-placeholder="@@Common_EnterFirstName"
                                            mask='A* A* A* A* A* A*' [dropSpecialCharacters]="false" />
                                        <div *ngIf="name.invalid && ((name.dirty || name.touched) || submitted == true)"
                                            class='invalidInputTextMessage'>
                                            <div *ngIf="name.errors?.['required']">
                                                <div i18n="@@Error_FirstNameRequired">First name is Required</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="mb-3">
                                        <label for="billinginfo-lastName" class="form-label">Last Name</label>
                                        <input required #lastname="ngModel"
                                            [ngClass]="{ 'is-invalid': (lastname.invalid && ((lastname.dirty || lastname.touched) || submitted == true))}"
                                            class="form-control" type="text" [(ngModel)]="userModel.lastName"
                                            placeholder="Enter Last Name" i18n-placeholder="@@Common_EnterLastName"
                                            mask='A* A* A* A* A* A*' [dropSpecialCharacters]="false" />
                                        <div *ngIf="lastname.invalid && ((lastname.dirty || lastname.touched) || submitted == true)"
                                            class='invalidInputTextMessage'>
                                            <!-- this is the style of form-invalid -->
                                            <div *ngIf="lastname.errors?.['required']">
                                                <div i18n="@@">Last name is Required</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="mb-3">
                                        <label for="billinginfo-email" class="form-label">Email
                                        </label>
                                        <input class="form-control" type="text" required [pattern]=emailPattern
                                            #email="ngModel"
                                            [ngClass]="{ 'is-invalid': (email.invalid && ((email.dirty || email.touched) || submitted == true))}"
                                            placeholder="Enter Email"
                                            i18n-placeholder="@@ContactPopUp_PlaceHolder_email"
                                            [(ngModel)]="userModel.email" />
                                        <div *ngIf="(email.invalid && ((email.dirty || email.touched) || submitted == true))"
                                            class='invalidInputTextMessage'>
                                            <div *ngIf="email.errors?.['required'] else elseEmail">
                                                <div i18n="@@Error_EmailRequired">Email is Required</div>
                                            </div>
                                            <ng-template #elseEmail>
                                                <div *ngIf="email.invalid">
                                                    <div i18n="@@ContactPopUp_Error_EmailInvalid">Email Invalid</div>
                                                </div>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="mb-3">
                                        <label for="billinginfo-phone" class="form-label">Phone</label>
                                        <input type="text" class="form-control" id="billinginfo-phone" #phone="ngModel"
                                            [ngClass]="{ 'is-invalid': (phone.invalid && ((phone.dirty || phone.touched) || submitted == true))}"
                                            placeholder="Enter phone number" value={{userModel.phoneNumber}}
                                            mask="(000) 000 0000" [(ngModel)]="userModel.phoneNumber"
                                            [dropSpecialCharacters]="false">
                                        <div *ngIf="(phone.invalid && ((phone.dirty || phone.touched) || submitted == true))"
                                            class='invalidInputTextMessage'>

                                            <div *ngIf="phone.invalid">
                                                <div i18n="">Phone Number Invalid</div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="d-flex align-items-start gap-2 mt-2">

                                <button type="button" class="btn btn-primary btn-label right ms-auto nexttab"
                                    (click)="tabToPayment()"><i
                                        class="ri-bank-card-line label-icon align-middle fs-16 ms-2"></i>Continue to
                                    Payment</button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </li>

            <li [ngbNavItem]="2" class="nav-item">
                <a ngbNavLink class="nav-link fs-15 p-3" role="tab">
                    <i
                        class="ri-bank-card-line fs-16 p-2 bg-soft-primary text-primary rounded-circle align-middle me-2"></i>
                    Payment Info
                </a>
                <ng-template ngbNavContent>

                    <div style="margin:  1.25rem;">

                        <!-- <span *ngIf="stripePayment == true else elseDefaultPaymentProcess">
                           
                            <div>
                                <h5 class="mb-1">Credit Card Information</h5>
                                <p class="text-muted mb-3">Please enter your billing information</p>
                            </div>

                            <form id="payment-form">
                                <div id="payment-element">
                                    <!--Stripe.js injects the Payment Element-->
                                       <!--
                                </div>

                            </form>

                        </span>

                        <ng-template #elseDefaultPaymentProcess> -->
                            <div>
                                <h5 class="mb-1">Payment Selection</h5>
                                <p class="text-muted mb-3">Please select and enter your billing information</p>
                            </div>

                            <div class="row g-4 pb-3">
                                <div class="col-lg-4 col-sm-6">
                                    <div data-bs-toggle="collapse" data-bs-target="#paymentmethodCollapse"
                                        aria-expanded="true" aria-controls="paymentmethodCollapse">
                                        <div class="form-check card-radio">
                                            <input id="paymentMethod02" name="paymentMethod" type="radio"
                                                class="form-check-input" checked>
                                            <label class="form-check-label" for="paymentMethod02">
                                                <span class="fs-16 text-muted me-2"><i
                                                        class="ri-bank-card-fill align-bottom"></i></span>
                                                <span class="fs-14 text-wrap">Credit / Debit Card</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <app-creditcard [showUpdate]="true" [newCard]="newCard" [submitted]="submitted"
                                [includeValidation]="true" [userCreditcard]="userModel.paymentInfo"
                                (userCreditcardChange)="userModel.paymentInfo=$event"></app-creditcard>

                        <!-- </ng-template> -->
                         
                        <div class="d-flex align-items-start gap-2 mt-4">
                            <button [disabled]=isLoading type="button" class="btn btn-primary btn-label"
                                (click)="tabToInfo()"><i
                                    class="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>Back
                                to
                                Information</button>
                            <button [disabled]=isLoading type="button"
                                class="btn btn-primary btn-label right ms-auto nexttab" (click)="tabToFinish()"><i
                                    class="ri-shopping-basket-line label-icon align-middle fs-16 ms-2"></i>Complete
                                Order</button>
                        </div>
                    </div>
                </ng-template>
            </li>
            <li [ngbNavItem]="3" class="nav-item">
                <a ngbNavLink class="nav-link fs-15 p-3" data-bs-toggle="tab" role="tab">
                    <i
                        class="ri-checkbox-circle-line fs-16 p-2 bg-soft-primary text-primary rounded-circle align-middle me-2"></i>Finish
                </a>
                <ng-template ngbNavContent>
                    <div style="margin:  1.25rem;">
                        <div class="text-center py-5">
                            <div class="mb-4">
                                <lord-icon src="https://cdn.lordicon.com/lupuorrc.json" trigger="loop"
                                    colors="primary:#0ab39c,secondary:#405189"
                                    style="width:120px;height:120px"></lord-icon>
                            </div>
                            <h5>Thank you! Your Order is Completed!</h5>
                            <p class="text-muted">You will receive an order confirmation email with
                                details of your order.</p>
                        </div>
                    </div>
                </ng-template>
            </li>
        </ul>
    </div>
    <div class="tab-content">
        <div [ngbNavOutlet]="customNav"></div>
    </div>
</div>